import React, {useState, useEffect} from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import SelectInfinite from '../../components/FormFields/SelectInfinite';
import InputText from '../../components/FormFields/InputText';
import TextArea from '../../components/FormFields/Textarea';
import * as yup from 'yup';
import {getLanguage, t} from 'react-switch-lang';
import {Col, Row} from 'react-bootstrap';
import {
  getAllSubProcesses,
  editPotentialRisk,
  getRiskFile,
  getRiskEstimations,
  getAllSubCauses,
  getDepartment,
} from '../../services/potentialRiskService';
import SelectList from '../../components/select/SelectList';
import './PotentialRisk.scss';
import {useUserContext} from '../../contexts/UserContext';
import Toast from '../../components/toast/Toast';
import Trash from './img/trash.svg';
import 'antd/dist/antd.css';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import DownloadOutlined from '@ant-design/icons/lib/icons/DownloadOutlined';
import allowedFileTypes from '../../utils/allowedFileTypes';
import {ReactComponent as PlusImg} from './img/PlusLightBlue.svg';
import {useHistory} from 'react-router-dom';
import InputDate from '../../components/FormFields/inputDate/InputDate';
import PreventTransitionPrompt from '../../components/preventTransitionprompt/PreventTransition';

const PotentialRisk = ({defaultData}) => {
  const lang = getLanguage();
  const user = useUserContext();
  const userDepartment = useDepartmentContext();

  const history = useHistory();

  const [disableSubprocess, setDisableSubPorcess] = useState(true);
  const [subProcesses, setSubProcesses] = useState([]);
  const [subCauses, setSubCauses] = useState([]);
  const disableRiskEstimation = true;
  const [riskEstimation, setRiskEstimation] = useState(
    lang === 'eng'
      ? defaultData.riskEstimationEvaluationEn
      : defaultData.riskEstimationEvaluation
  );
  const [riskEstimationId, setRiskEstimationId] = useState(
    defaultData.riskEstimationId
  );
  const [riskEstimationColor, setRiskEstimationColor] = useState(
    defaultData.riskEstimationColor
  );

  const [disabledRisk, setDisabledRisk] = useState(true);
  const [potentialRisk, setPotentialRisk] = useState({
    id: defaultData.id,
    riskStatusId: defaultData.riskStatusId,

    ...(defaultData.potentialRiskTypeId !== null
      ? {
          potentialRiskType: {
            value:
              defaultData.potentialRiskTypeId !== null
                ? defaultData.potentialRiskTypeId
                : null,
            label:
              defaultData.potentialRiskTypeId !== null
                ? lang === 'eng'
                  ? defaultData.potentialRiskTypeNameEn
                  : defaultData.potentialRiskTypeName
                : null,
          },
        }
      : {potentialRiskType: null}),
    title: defaultData.title,
    description: defaultData.description,
    riskCause: {
      value: defaultData.riskCauseId,
      label:
        lang === 'eng'
          ? defaultData.riskCauseNameEn
          : defaultData.riskCauseName,
    },
    riskCategory: {
      value: defaultData.riskCategoryId,
      label:
        lang === 'eng'
          ? defaultData.riskCategoryNameEn
          : defaultData.riskCategoryName,
    },
    ...(defaultData.processId !== null
      ? {
          process: {
            value: defaultData.processId,
            label:
              lang === 'eng'
                ? defaultData.processNameEn
                : defaultData.processName,
          },
        }
      : {process: null}),

    ...(defaultData.subprocessId !== null
      ? {
          subprocess: {
            value: defaultData.subprocessId,
            label:
              lang === 'eng'
                ? defaultData.subprocessNameEn
                : defaultData.subprocessName,
          },
        }
      : {subprocess: null}),
    ...(defaultData.businessLineId !== null
      ? {
          businessLine: {
            value: defaultData.businessLineId,
            label:
              lang === 'eng'
                ? defaultData.businessLineNameEn
                : defaultData.businessLineName,
          },
        }
      : {businessLine: null}),
    methodology: {
      value: defaultData.methodologyId,
      label:
        lang === 'eng'
          ? defaultData.methodologyNameEn
          : defaultData.methodologyName,
    },
    departmentStakeholder: {
      value: defaultData.departmentStakeholderId,
      label:
        lang === 'eng'
          ? defaultData.departmentStakeholderNameEn
          : defaultData.departmentStakeholderName,
    },
    comment: defaultData.comment,
    files: defaultData.files,
    userInChargeRisk:
      defaultData.userInChargeFirstName +
      ' ' +
      defaultData.userInChargeLastName,
    responsibleUserRisk:
      defaultData.userResponsibleFirstName +
      ' ' +
      defaultData.userResponsibleLastName,
    financialPerformance: {
      value: defaultData.financialPerformanceId,
      label:
        lang === 'eng'
          ? defaultData.financialPerformanceNameEn
          : defaultData.financialPerformanceName,
    },
    frequencyOccurenceRisk: {
      value: defaultData.frequencyOccurenceRiskId,
      label:
        lang === 'eng'
          ? defaultData.frequencyOccurenceRiskNameEn
          : defaultData.frequencyOccurenceRiskName,
    },
    riskEstimationEvaluation: defaultData.riskEstimationEvaluation,
    riskEstimationId: defaultData.riskEstimationId,
    riskEstimationColor: defaultData.riskEstimationColor,
    riskSubCause: {
      value: defaultData.riskSubCauseId,
      label:
        lang === 'eng'
          ? defaultData.riskSubCauseNameEn
          : defaultData.riskSubCauseName,
    },
  });
  const [files, setFiles] = useState([]);
  const [deleteFiles, setDeleteFiles] = useState([]);

  const [schema, setSchema] = useState(
    yup.object().shape({
      title: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(150, t('message.max', {max: 150})),
      potentialRiskType: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      description: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(2048, t('message.max', {max: 2048})),
      riskCause: yup.object().nullable().required(t('message.fieldRequired')),
      riskCategory: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      process: yup.object().nullable().required(t('message.fieldRequired')),
      subprocess: yup.object().nullable().required(t('message.fieldRequired')),
      businessLine: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      methodology: yup.object().nullable().required(t('message.fieldRequired')),
      departmentStakeholder: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      frequencyOccurrenceOr: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      financialPerformance: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      riskMitigationModeName: yup.object().nullable().required(t('message.fieldRequired')),
      comment: yup
        .string()
        .trim()
        .max(2048, t('message.max', {max: 2048})),
      departmentSourceId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
    })
  );

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, setValue} = methods;
  const watchProcess = watch('process');
  const watchFrequencyOccurrenceOr = watch('frequencyOccurrenceOr');
  const watchFinancialPerformance = watch('financialPerformance');
  const watchRiskCause = watch('riskCause');
  const watchDepartmentSourceId = watch('departmentSourceId');

  const fetchSubprocesses = async () => {
    try {
      const {data} = await getAllSubProcesses(watchProcess['value']);
      return data;
    } catch (e) {}
  };

  const fetchSubCauses = async () => {
    try {
      const {data} = await getAllSubCauses(watchRiskCause['value']);
      // setSubProcesses(data);
      return data;
    } catch (e) {}
  };

  const fetchRiskEstimation = async () => {
    try {
      const {data} = await getRiskEstimations(
        watchFrequencyOccurrenceOr['value'],
        watchFinancialPerformance['value']
      );
      return data;
    } catch (e) {}
  };

  useEffect(() => {
    window.location.pathname.includes('edit')
      ? setDisabledRisk(false)
      : setDisabledRisk(true);
  }, []);

  useEffect(() => {
    if (watchRiskCause?.value) {
      fetchSubCauses().then((r) => {
        let subCauses = [];
        r.forEach((item) => {
          subCauses.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });
        setSubCauses(subCauses);
      });
    }
    if (watchRiskCause === null) {
      setValue('riskSubCause', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchRiskCause]);

  const handleCancel = (e) => {
    e.preventDefault();
    window.location = `/potential-risk/${defaultData.id}`;
  };

  const submitForm = async (data) => {
    const files = document.getElementById('upload').files;
    const payload = {
      id: parseInt(potentialRisk.id),
      riskStatusId: potentialRisk.riskStatusId,
      applicationDate: new Date(defaultData.applicationDate),

      title: data.title,
      potentialRiskTypeId: data.potentialRiskType.value,
      description: data.description,
      riskCauseId: data.riskCause.value,
      riskSubCauseId: data.riskSubCause.value,
      riskCategoryId: data.riskCategory.value,
      riskTypeId: 1,
      userCreatedId: user.id,
      userInChargeId: user.id,
      userInChargeLogin: user.login,
      userResponsibleId: data.userResponsible.value,
      userResponsibleLogin: userDepartment[0].userResponsibleLogin,
      processId: data.process.value,
      subprocessId: data.subprocess.value,
      businessLineId: data.businessLine.value,
      methodologyId: data.methodology.value,
      departmentStakeholderId: data.departmentStakeholder.value,
      departmentSourceId: data.departmentSourceId.value,
      riskEstimationId: riskEstimationId,
      riskMitigationModeId: data.riskMitigationModeName?.value,
      riskMitigationModeName: data.riskMitigationModeName?.label,
      comment: data.comment,
      deleteFiles: deleteFiles,
    };
    try {
      const response = await editPotentialRisk(payload, files);
      if (response.status === 200) {
        await Toast.fire({
          title: t('potentialRisk.messages.editSuccess'),
          icon: 'success',
        });
      }
      window.location = `/potential-risk/${parseInt(potentialRisk.id)}`;
    } catch (err) {
      if (err.response.data.code === 'risk-exists') {
        Toast.fire({
          title:
            lang === 'eng'
              ? err.response.data.description
              : t('potentialRisk.messages.addErrorExists'),
          icon: 'error',
        });
        document.getElementById('title').focus();
        document.getElementById('title').select();
      } else {
        Toast.fire({
          title: t('potentialRisk.messages.editError'),
          icon: 'error',
        });
      }
    }
  };

  useEffect(() => {
    if (watchProcess?.value) {
      fetchSubprocesses().then((r) => {
        if (window.location.pathname.includes('edit')) {
          setDisableSubPorcess(false);
        }
        let subProcesses = [];
        r.forEach((item) => {
          subProcesses.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });
        setSubProcesses(subProcesses);
      });
    }
    if (watchProcess === null) {
      setDisableSubPorcess(true);
      setValue('subprocess', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchProcess]);

  const getRiskColor = (risk) => {
    if(risk.color === 'PINE_GREEN') {
      setRiskEstimationColor('#027148')
    }
    if (risk.color === 'RED') {
      setRiskEstimationColor('#f5501f');
    }
    if (risk.color === 'YELLOW') {
      setRiskEstimationColor('#f59a1f');
    }
    if (risk.color === 'GREEN') {
      setRiskEstimationColor('#37c35c');
    }
    if(risk.color === 'ORANGE') {
      setRiskEstimationColor('#FFBF00')
    }
  };

  useEffect(() => {
    if (watchFrequencyOccurrenceOr?.value && watchFinancialPerformance?.value) {
      fetchRiskEstimation().then((r) => {
        const risk = r[0];
        if (risk.evaluation !== riskEstimation) {
          setRiskEstimation(
            lang === 'eng' ? risk.evaluationEn : risk.evaluation
          );
          getRiskColor(risk);
          setRiskEstimationId(risk.id);
        } else {
          // Needs to be set 2 times since key rerender reacts only on change
          setRiskEstimation('');
          setRiskEstimation(riskEstimation);

          setRiskEstimationColor('');
          getRiskColor(risk);
          setRiskEstimationId(risk.id);
        }
      });
    }
    setValue('riskEstimation', '');
    if (
      watchFrequencyOccurrenceOr === null ||
      watchFinancialPerformance === null
    ) {
      setRiskEstimation('');
      setRiskEstimationColor('');
      setRiskEstimationId();
    }
  }, [watchFrequencyOccurrenceOr, watchFinancialPerformance]);

  const uploadOnChange = () => {
    const input = document.getElementById('upload');
    let children = [];
    if (input.files.length > 10) {
      Toast.fire({
        title: t('message.tooManyFiles'),
        icon: 'error',
      });
    } else {
      for (let i = 0; i < input.files.length; ++i) {
        const allowedTypesArray = allowedFileTypes.split(',');
        let fileExtension = input.files
          .item(i)
          .name.substring(input.files.item(i).name.lastIndexOf('.')).toLowerCase();
        if (!allowedTypesArray.includes(fileExtension)) {
          Toast.fire({
            title: t('message.fileTypeNotAllowed', {
              entity: input.files.item(i).name,
            }),
            icon: 'error',
          });
        } else {
          if (input.files.item(i).size > 10485760) {
            Toast.fire({
              title: t('message.fileTooBig'),
              icon: 'error',
            });
          } else {
            children.push({
              id: input.files.item(i).name,
              label: input.files.item(i).name,
            });
            setFiles(children);
          }
        }
      }
    }
  };

  const clearFetchedFile = (id) => {
    let children = potentialRisk.files.filter((file) => file.id !== id);
    setPotentialRisk({...potentialRisk, ['files']: children});
    setDeleteFiles([...deleteFiles, id]);
  };

  const clearLocalFile = (index) => {
    const dt = new DataTransfer();
    const input = document.getElementById('upload');
    const {files} = input;
    let children = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (index !== i) {
        dt.items.add(file); // here you exclude the file
        children.push({
          id: input.files.item(i).name,
          label: input.files.item(i).name,
        });
      }
    }
    input.files = dt.files;
    setFiles(children);
  };

  const toAddIncurred = () => {
    history.push({
      pathname: `/incurred-risk/add`,
      state: {potentialId: defaultData.id, potentialTitlе: defaultData.title},
    });
  };

  // useEffect(() => {
  //   if (watchDepartmentSourceId) {
  //     const depratmentObject = async () => {
  //       try {
  //         const {data} = await getDepartment(watchDepartmentSourceId.value);
  //         setValue('userResponsible', {
  //           value: data[0].userResponsibleId,
  //           label:
  //             data[0].userResponsibleFirstName +
  //             ' ' +
  //             data[0].userResponsibleLastName,
  //         });
  //       } catch {}
  //     };
  //     depratmentObject();
  //   }
  // }, [watchDepartmentSourceId]);


  return (
    <>
      {defaultData !== undefined && (
        <>
          <PreventTransitionPrompt when={!disabledRisk} />
          <div className="form mt-4 w-100 pb-4">
            <div className="mt-4">
              {defaultData?.active === true && user.authorities.includes('ROLE_USER_IN_CHARGE') && (
                <Row className="mb-2 justify-content-end px-3">
                  <button
                    type="button"
                    className="secondary-btn float-right"
                    onClick={toAddIncurred}
                  >
                    <PlusImg />
                    <span className="ml-2">
                      {t('navbar.resultingAdverseEvent')}
                    </span>
                  </button>
                </Row>
              )}

              <FormProvider {...methods}>
                <form onSubmit={handleSubmit(submitForm)}>
                  <Row className="field-group-title">
                    <Col className="col-4 col-xl-2">
                      {t('potentialRisk.mainData')}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="col-6 col-xl-3">
                      <label className="label-potential-risk">
                        {t('potentialRisk.title')}
                      </label>
                      <InputText
                        type="text"
                        name="title"
                        className="form-control input-field"
                        placeholder={t('potentialRisk.placeholder.title')}
                        defaultValue={potentialRisk.title}
                        disabled={disabledRisk}
                        id="title"
                      />
                      <label className="label-potential-risk">
                        {t('potentialRisk.potentialRiskType')}
                      </label>
                      <SelectInfinite
                        api="potential-risk-types"
                        name="potentialRiskType"
                        placeholder={t(
                          'potentialRisk.placeholder.potentialRiskType'
                        )}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        defaultValue={potentialRisk.potentialRiskType}
                        isDisabled={disabledRisk}
                      />
                    </Col>
                    <Col className="col-6 col-xl-3">
                      <label className="label-potential-risk">
                        {t('potentialRisk.description')}
                      </label>
                      <TextArea
                        name="description"
                        className={`form-control text-area `}
                        placeholder={t('potentialRisk.placeholder.description')}
                        disabled={disabledRisk}
                        defaultValue={potentialRisk.description}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-5 field-group-title">
                    <Col className="col-6 col-xl-3">
                      {t('potentialRisk.additionalInformation')}
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col className="col-3 col-xl-3">
                      <label className="label-potential-risk">
                        {t('potentialRisk.riskCategory')}
                      </label>
                      <SelectInfinite
                        api="risk-categories"
                        name="riskCategory"
                        placeholder={t(
                          'potentialRisk.placeholder.riskCategory'
                        )}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        selected={potentialRisk.riskCategory}
                        isDisabled={disabledRisk}
                      />
                      <label className="label-potential-risk">
                        {t('potentialRisk.riskCause')}
                      </label>
                      <SelectInfinite
                        api="risk-causes"
                        name="riskCause"
                        placeholder={t('potentialRisk.placeholder.riskCause')}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        selected={potentialRisk.riskCause}
                        isDisabled={disabledRisk}
                      />
                      <label className="label-potential-risk">
                        {t('potentialRisk.riskSubCause')}
                      </label>
                      <SelectList
                        name="riskSubCause"
                        isDisabled={disabledRisk}
                        className="select"
                        placeholder={t(
                          'potentialRisk.placeholder.riskSubCause'
                        )}
                        options={subCauses}
                        isClearable
                        selected={potentialRisk.riskSubCause}
                      />
                    </Col>
                    <Col className="col-3 col-xl-3">
                      <label className="label-potential-risk">
                        {t('potentialRisk.businessLine')}
                      </label>
                      <SelectInfinite
                          api="business-lines"
                          name="businessLine"
                          placeholder={t(
                              'potentialRisk.placeholder.businessLine'
                          )}
                          labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                          className="select"
                          selected={potentialRisk.businessLine}
                          isDisabled={disabledRisk}
                      />
                      <label className="label-potential-risk">
                        {t('potentialRisk.process')}
                      </label>
                      <SelectInfinite
                        api="processes"
                        name="process"
                        placeholder={t('potentialRisk.placeholder.process')}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        selected={potentialRisk.process}
                        isDisabled={disabledRisk}
                      />
                      <label className="label-potential-risk">
                        {t('potentialRisk.subprocess')}
                      </label>
                      <SelectList
                        name="subprocess"
                        key={subProcesses}
                        isDisabled={disableSubprocess}
                        placeholder={t('potentialRisk.placeholder.subprocess')}
                        options={subProcesses}
                        isClearable
                        selected={potentialRisk.subprocess}
                      />
                    </Col>
                    <Col className="col-3 col-xl-3">
                      <label className="label-potential-risk">
                        {t('potentialRisk.methodology')}
                      </label>
                      <SelectInfinite
                        api="methodologies"
                        name="methodology"
                        placeholder={t('potentialRisk.placeholder.methodology')}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        selected={potentialRisk.methodology}
                        isDisabled={disabledRisk}
                      />

                      {/* oj koja je kreirala rizik */}
                      <label className="label-potential-risk">
                        {t('potentialRisk.departmentRisk')}
                      </label>
                      {userDepartment?.length > 1 ? (
                        <SelectInfinite
                          api="departments/departments-user-in-charge"
                          name="departmentSourceId"
                          placeholder={t(
                            'potentialRisk.placeholder.departmentRisk'
                          )}
                          labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                          className="select"
                          isDisabled={disabledRisk}
                          defaultValue={{
                            value: defaultData.departmentSourceId,
                            label:
                              lang === 'mne'
                                ? defaultData.departmentSourceName
                                : defaultData.departmentSourceNameEn,
                          }}
                        />
                      ) : (
                        <SelectInfinite
                          api="departments/departments-user-in-charge"
                          name="departmentSourceId"
                          placeholder={t(
                            'potentialRisk.placeholder.departmentRisk'
                          )}
                          labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                          className="select"
                          defaultValue={{
                            value: defaultData.departmentSourceId,
                            label:
                              lang === 'mne'
                                ? defaultData.departmentSourceName
                                : defaultData.departmentSourceNameEn,
                          }}
                          isDisabled={true}
                        />
                      )}

                      <label className="label-potential-risk">
                        {t('potentialRisk.frequencyOccurrenceOr')}
                      </label>
                      <SelectInfinite
                        api="frequency-occurence-risks"
                        name="frequencyOccurrenceOr"
                        placeholder={t(
                          'potentialRisk.placeholder.frequencyOccurrenceOr'
                        )}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        selected={potentialRisk.frequencyOccurenceRisk}
                        isDisabled={disabledRisk}
                      />
                    </Col>
                    <Col className="col-3 col-xl-3">
                      <label className="label-potential-risk">
                        {t('potentialRisk.departmentStakeholder')}
                      </label>
                      <SelectInfinite
                        api="departments"
                        name="departmentStakeholder"
                        placeholder={t(
                          'potentialRisk.placeholder.departmentStakeholder'
                        )}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        selected={potentialRisk.departmentStakeholder}
                        isDisabled={disabledRisk}
                      />

                      {/* odgovorno lice */}
                      <label className="label-potential-risk">
                        {t('potentialRisk.userResponsible')}
                      </label>
                      <SelectInfinite
                        api="users"
                        name="userResponsible"
                        labelKey="firstName"
                        placeholder={t(
                          'potentialRisk.placeholder.userResponsible'
                        )}
                        className="select"
                        isDisabled={true}
                        defaultValue={{
                          value: defaultData.userResponsibleId,
                          label:
                            defaultData.userResponsibleFirstName +
                            ' ' +
                            defaultData.userResponsibleLastName,
                        }}
                      />

                      <label className="label-potential-risk">
                        {t('incurred-risk.userInCharge')}
                      </label>
                      <SelectInfinite
                        api="users"
                        name="users"
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        isDisabled={true}
                        defaultValue={{
                          value: defaultData.userInChargeId,
                          label:
                            defaultData.userInChargeFirstName +
                            ' ' +
                            defaultData.userInChargeLastName,
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="col-6 col-xl-3 pb-4">
                      <label className="label-potential-risk">
                        {t('potentialRisk.riskEstimation')}
                      </label>
                      {/*Can't use InputText component since it has ref register and color needs to change*/}
                      {/*passing !important trough another ref since react doesn't accept it in inline style as variable (#ffffff !important)*/}
                      <input
                        key={riskEstimationId}
                        className="form-control input-field"
                        value={riskEstimation?.toUpperCase()}
                        type="text"
                        disabled={disableRiskEstimation}
                        ref={(el) => {
                          if (el) {
                            el.style.setProperty(
                              'color',
                              riskEstimationColor,
                              'important'
                            );
                          }
                        }}
                      />
                      <label className="label-potential-risk">
                        {t('mitigation-measures.method')}
                      </label>
                      <SelectInfinite
                          api="/risk-mitigation-modes"
                          name="riskMitigationModeName"
                          labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                          className="select"
                          placeholder={t('placeholder.riskMitigrationMethod')}
                          isDisabled={disabledRisk}
                          defaultValue={{label: defaultData.riskMitigationModeName,
                            value: defaultData.riskMitigationModeId}}
                      />
                    </Col>
                    <Col className="col-3 col-xl-3 pb-4">
                      {!disabledRisk ? (
                          // Adding new files
                          <>
                            <label
                                className="label-potential-risk"
                                htmlFor={'attachFile'}
                            >
                              {t('potentialRisk.attachFiles')}
                            </label>
                            <span className="optional register">
                            {t('common.optional')}
                          </span>
                            <InputText
                                id="upload"
                                type="file"
                                name="file"
                                multiple
                                disabled={disabledRisk}
                                className="file-input"
                                onChange={uploadOnChange}
                                accept={allowedFileTypes}
                            />
                            <ul className="mb-0" key={potentialRisk}>
                              {potentialRisk.files.map((file) => (
                                  <li key={file.id}>
                                    <div className="d-flex align-items-center">
                                      <span className="mr-2">{file.fileName}</span>
                                      {disabledRisk ? (
                                          <DownloadOutlined
                                              onClick={() => {
                                                getRiskFile(file.id, file.fileName);
                                              }}
                                          />
                                      ) : (
                                          <img
                                              src={Trash}
                                              alt="trash"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                clearFetchedFile(file.id);
                                              }}
                                          />
                                      )}
                                    </div>
                                  </li>
                              ))}
                            </ul>
                            <ul key={files}>
                              {files.map((file, index) => (
                                  <li key={file.id}>
                                    <div className="d-flex align-items-center">
                                      <span className="mr-2">{file.label}</span>
                                      <img
                                          src={Trash}
                                          alt="trash"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            clearLocalFile(index);
                                          }}
                                      />
                                    </div>
                                  </li>
                              ))}
                            </ul>
                          </>
                      ) : (
                          // Editing files
                          <div>
                            {potentialRisk.files.length > 0 ? (
                                <>
                                  <label className="label-potential-risk">
                                    {t('potentialRisk.attachedFiles')}
                                  </label>
                                  <span className="optional register">
                                {t('common.optional')}
                              </span>
                                  <div>
                                    <ul>
                                      {potentialRisk.files.map((file) => (
                                          <li key={file.id}>
                                            <div className="d-flex align-items-center">
                                        <span className="mr-2">
                                          {file.fileName}
                                        </span>
                                              <DownloadOutlined
                                                  onClick={() => {
                                                    getRiskFile(file.id, file.fileName);
                                                  }}
                                              />
                                            </div>
                                          </li>
                                      ))}
                                    </ul>
                                  </div>
                                </>
                            ) : null}
                          </div>
                      )}
                    </Col>
                    <Col className="col-3 col-xl-3 pb-4">
                      <label className="label-potential-risk">
                        {t('potentialRisk.comment')}
                      </label>
                      <span className="optional register">
                        {t('common.optional')}
                      </span>
                      <TextArea
                          name="comment"
                          className={`form-control text-area`}
                          placeholder={t('potentialRisk.placeholder.comment')}
                          disabled={disabledRisk}
                          defaultValue={
                            potentialRisk.comment ? potentialRisk.comment : ''
                          }
                      />
                    </Col>
                    <Col>
                      <label className="label-potential-risk">
                        {t('potentialRisk.financialPerformance')}
                      </label>
                      <SelectInfinite
                          api="financial-performances"
                          name="financialPerformance"
                          placeholder={t(
                              'potentialRisk.placeholder.financialPerformance'
                          )}
                          labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                          className="select"
                          selected={potentialRisk.financialPerformance}
                          isDisabled={disabledRisk}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-4 field-group-title">
                    <Col className="col-6 col-xl-3">
                      {t('litigation.systemAddedInformation')}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col className="col-6 col-xl-3">
                      <label className="label-potential-risk">
                        {t('incurred-risk.id')}
                      </label>
                      <InputText
                        type="text"
                        name="id"
                        className="form-control input-field"
                        disabled={true}
                        defaultValue={defaultData?.id}
                      />
                    </Col>
                    <Col className="col-6 col-xl-3">
                      <label className="label-potential-risk">
                        {t('incurred-risk.date')}
                      </label>
                      <InputDate
                        name="creationDate"
                        className="form-control input-field"
                        // defaultValue={new Date(defaultData.applicationDate)}
                        selected={new Date(defaultData.applicationDate)}
                        disabled={true}
                      />
                    </Col>
                    <Col className="col-6 col-xl-3">
                      <label className="label-potential-risk">
                        {t('incurred-risk.status')}
                      </label>
                      <SelectInfinite
                        api="risk-statuses"
                        name="riskStatus"
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        isDisabled={true}
                        defaultValue={{
                          value: defaultData.riskStatusId,
                          label:
                            lang === 'mne'
                              ? defaultData.riskStatusName
                              : defaultData.riskStatusNameEn,
                        }}
                      />
                    </Col>

                    
                    {/* <Col className="col-6 col-xl-3">
                      <label className="label-potential-risk">
                        {t('incurred-risk.departmentSource')}
                      </label>
                      <SelectInfinite
                        api="departments"
                        name="departments"
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        isDisabled={true}
                        defaultValue={{
                          value: defaultData.departmentSourceId,
                          label:
                            lang === 'mne'
                              ? defaultData.departmentSourceName
                              : defaultData.departmentSourceNameEn,
                        }}
                      />
                    </Col> */}
                  </Row>
                  <Row className="mb-3">
                    {/* odgovorno i zaduzeno lice oj koja je kreirala rizik */}
                    {/* <Col className="col-6 col-xl-3">
                      <label className="label-potential-risk">
                        {t('incurred-risk.userInCharge')}
                      </label>
                      <SelectInfinite
                        api="users"
                        name="users"
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        isDisabled={true}
                        defaultValue={{
                          value: defaultData.userInChargeId,
                          label:
                            defaultData.userInChargeFirstName +
                            ' ' +
                            defaultData.userInChargeLastName,
                        }}
                      />
                    </Col>
                    <Col className="col-6 col-xl-3">
                      <label className="label-potential-risk">
                        {t('incurred-risk.responsibleUser')}
                      </label>
                      <SelectInfinite
                        api="users"
                        name="users"
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        isDisabled={true}
                        defaultValue={{
                          value: defaultData.userResponsibleId,
                          label:
                            defaultData.userResponsibleFirstName +
                            ' ' +
                            defaultData.userResponsibleLastName,
                        }}
                      />
                    </Col> */}
                  </Row>
                  <div>
                    {!disabledRisk ? (
                      <Row className="form-footer w-100" key={disabledRisk}>
                        <button
                          className="secondary-btn"
                          type="reset"
                          onClick={handleCancel}
                        >
                          {t('buttons.cancel')}
                        </button>
                        <button className="primary-btn">
                          {t('buttons.save')}
                        </button>
                      </Row>
                    ) : null}
                  </div>
                </form>
              </FormProvider>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PotentialRisk;
